import type { FC } from 'react';

import type { TypeSelectionStepProps } from '@/sections/seeds/components/modals/AddSeedByTypeModal/AddSeedByTypeModal.types';
import { SeedTypeSelector } from '@/sections/seeds/components/modals/AddSeedByTypeModal/SeedTypeSelector';
import { SeedTypeOption } from '@/types';

/**
 * Step 1: Type Selection
 *
 * Renders the seed type selector (Network Assets, Web Applications, Web Services)
 * and displays any subscription errors.
 */
export const TypeSelectionStep: FC<TypeSelectionStepProps> = ({
  formData,
  setFormData,
  subscriptionError,
}) => {
  const handleTypeChange = (type: SeedTypeOption) => {
    setFormData(prev => ({ ...prev, seedType: type }));
  };

  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-6">
      <div className="flex flex-col gap-1.5 text-center">
        <h3 className="text-chariot-text-primary text-base font-semibold">
          What do you want to scan?
        </h3>
        <p className="text-chariot-text-secondary text-sm">
          Choose the type of target to add. You can enter specific entries next.
        </p>
      </div>
      <div className="w-full max-w-md">
        <SeedTypeSelector
          value={formData.seedType}
          onChange={handleTypeChange}
        />
      </div>
      {subscriptionError && (
        <div className="border-chariot-stroke-critical bg-chariot-stroke-critical/10 w-full max-w-md rounded-md border p-3">
          <div className="text-chariot-stroke-critical text-sm">
            {subscriptionError}
          </div>
        </div>
      )}
    </div>
  );
};
